import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { ChartDataSets, ChartOptions, ChartType } from 'chart.js';
import { MultiDataSet, Label, Color } from 'ng2-charts';

@Component({
  selector: 'app-doughnutchart',
  templateUrl: './doughnutchart.component.html',
  styleUrls: ['./doughnutchart.component.css']
})
export class DoughnutchartComponent implements OnInit {

  @Input() labels=[];
  @Input() data=[];
  @Input() colors=[];
  constructor() { }
// Doughnut
public doughnutChartLabels: Label[] ;
public doughnutChartData: MultiDataSet = [
  [350, 450, 100]
];
public doughnutChartType: ChartType = 'doughnut';
//  public doughnutChartData: ChartDataSets[] = [
//   { data: [65, 59, 80], label: 'Series A', barThickness: 0.2 }
// ];
public doughnutcolors: Color[];

public options: ChartOptions = {
  responsive: true, 
  //aspectRatio: 1,
  cutoutPercentage: 60,
  legend: {
    display: false,
    position: 'right',
    labels: {
      fontSize: 12,
      usePointStyle: true,
      padding: 30,
    }
  }
};

@Input('donchd') donchd: any;


ngOnInit(): void {
  this.doughnutChartLabels = this.labels;
  this.doughnutChartData = [this.data];
  this.doughnutcolors = [
  {
    backgroundColor: this.colors,
    borderWidth: 0
  }
]
 
}

ngOnChanges(changes: SimpleChanges): void {
  this.doughnutChartLabels = this.labels;
  this.doughnutChartData = [this.data];
  this.doughnutcolors = [
  {
    backgroundColor: this.colors,
    borderWidth: 0
  }
]
}


}
